import { useContext } from "react";

import SettingsContext, {
  SettingsType,
} from "@context/Settings/settingsContext";
import HeaderBackButton from "@shared-ui-components/HeaderBackButton";

import { SettingsWrapper } from "../style";
import ListItem from "./ListItem";

const Settings = () => {
  const [{ settingsState, settingsSetState }] = useContext(SettingsContext);

  const handleChange = () => {
    settingsSetState((prev: SettingsType) => {
      const settings = {
        planData: !prev.planData,
        foreCastData: !prev.foreCastData,
      };
      localStorage.setItem("settings", JSON.stringify(settings));
      return settings;
    });
  };

  return (
    <>
      <HeaderBackButton title="Settings" />
      <SettingsWrapper>
        <ListItem
          label="Plan Data"
          handleChange={handleChange}
          checked={settingsState.planData}
        />
        <ListItem
          label="Forecast Data"
          handleChange={handleChange}
          checked={settingsState.foreCastData}
        />
      </SettingsWrapper>
    </>
  );
};

export default Settings;
